import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { TextField, Button, Checkbox, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AddRole = () => {
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      name: "Dashboard",
    },
    {
      id: 2,
      name: "User Management",
    },
    {
      id: 3,
      name: "Offer Management",
    },
    {
      id: 4,
      name: "Butterfly Effect",
    },
    {
      id: 5,
      name: "Booking & RSVP Tracker",
    },
    {
      id: 6,
      name: "Category Management",
    },
    {
      id: 7,
      name: "Cancellation Requests",
    },
    {
      id: 8,
      name: "Group and Tags ",
    },
    {
      id: 9,
      name: "Reporting & Analytics",
    },
    {
      id: 10,
      name: "Notification & Email",
    },
    {
      id: 11,
      name: "Finance & Payments",
    },
    {
      id: 12,
      name: "Partner & Duo ",
    },
    {
      id: 13,
      name: "Coupon Management",
    },
    {
      id: 14,
      name: "Manage Sub-Admin",
    },
    {
      id: 15,
      name: "Analytics",
    },
    {
      id: 16,
      name: "Manage Subscriptions",
    },
    {
      id: 17,
      name: "Manage Payments",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 180,
      field: "name",
      headerName: "Module Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "view",
      headerName: "View",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <Checkbox />;
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "add",
      headerName: "Add",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <Checkbox />;
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "edit",
      headerName: "Edit",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <Checkbox />;
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "delete",
      headerName: "Delete",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => {
        return <Checkbox />;
      },
    },
  ];
  let hidden = ["fullName"];

  const goBack = () => {
    navigate(-1);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1 className="back_arrow">
          {" "}
          <IconButton onClick={() => goBack()}>
            {" "}
            <ArrowBackIcon />{" "}
          </IconButton>
          Add Role
        </h1>
      </div>

      <div className="cards table_cards v2">
        <div className="form">
          <div className="p_20">
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Role Name</label>
                <TextField
                  placeholder="Enter Role Name"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
            </div>
          </div>
          <div className="sorting_table mt_20">
            <TableComponent
              columns={columns?.filter((item) => !hidden.includes(item.field))}
              rows={rows}
            />
          </div>
          <div className="form_btn p_20">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default AddRole;
